import React from "react"
import { Row, Col } from "reactstrap"
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components"
import ContainerMax from "components/shared/ContainerMax"
import { LinkSearchReplace } from "utils/LinkSearchReplace"
import { media } from "utils/Media"

const Text = styled.div`
    background: rgba(255, 255, 255, 0.90);
    box-shadow: 10px 10px 10px 0px rgba(0, 0, 0, 0.25);
    padding: 2rem;
    color: black;

    h1, h2 {
        font-size: ${props => props.theme.font.h2.size};
        color: black;
        @media ${media.md} {
            font-size: ${props => props.theme.font.h1.size};
        }
    }

    a {
        color: black;
        font-family: ${props => props.theme.font.family.bold};
        text-decoration: underline;
    }
`

const BgImage = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    
    .gatbsy-image-wrapper, .gatsby-image-wrapper-constrained {
        height: 100%;
        width: 100%;
        position: absolute;
    }
`

const ImageTextV2 = (props) => {

    let id = ""
    if (props.block.anchorId !== null) {
        id = props.block.anchorId.toLowerCase()
        id = props.block.anchorId.replace(' ', '')
    }

    return (
        <div className="position-relative py-4 py-md-5 my-4">
            {props.block.backgroundImage && props.block.backgroundImageMobile && (
                <BgImage>
                    <GatsbyImage
                        image={props.block.backgroundImage.localFile.childImageSharp.gatsbyImageData}
                        alt={props.block.backgroundImage.altText}
                        className="d-none d-md-block"
                    />
                    <GatsbyImage
                        image={props.block.backgroundImageMobile.localFile.childImageSharp.gatsbyImageData}
                        alt={props.block.backgroundImageMobile.altText}
                        className="d-md-none"
                    />
                </BgImage>
            )}
            <ContainerMax
                id={id}
                maxWidth="1360"
                className="py-4"
            >
                <Row>
                    <Col md={{ size: 6, order: props.block.imagePosition === "right" ? 1 : 2 }} className="mb-4 mb-md-0">
                        <Text dangerouslySetInnerHTML={{ __html: LinkSearchReplace(props.block.text)}} />
                    </Col>
                    <Col md={{ offset: 1,size: 5, order: props.block.imagePosition === "right" ? 2 : 1 }}>
                        <GatsbyImage image={props.block.image.localFile.childImageSharp.gatsbyImageData} alt={props.block.image.altText} />
                    </Col>
                </Row>
            </ContainerMax>
        </div>
    );
}

export default ImageTextV2